<template>
    <paper class="train-list-adjust-paper">
        <div class="train-list-adjust-wrapper">
            <resizable-grids
                :start-width="600"
                :start-width-max="900"
                :start-width-min="360"
            >
                <template v-slot:grid-left>
                    <div class="train-list-list">
                        <div class="train-list-adjust-search">
                            <el-input
                                v-model="customerOrderNo"
                                clearable
                                placeholder="客户订单号"
                                @clear="handleSearchCustomerOrderNo"
                            >
                            </el-input>
                            <div style="min-width: 10px"></div>
                            <el-button
                                class="bigData-btn-search"
                                type="primary"
                                @click="handleSearchCustomerOrderNo"
                            >
                                {{
                                    $translate('component.E202006180033', {
                                        defaultText: '查 询',
                                    })
                                }}
                            </el-button>
                        </div>
                        <div class="train-list-adjust-list">
                            <train-adjust-list
                                :controller="daListController"
                                :do-add-task="doAddTaskForList"
                                :do-delete-task="doDeleteTaskForList"
                                :train-list="trains"
                                :adjustCheckDisable="adjustCheckDisable"
                                @on-arrange="handleArrange"
                                @on-expanded="handleExpandedAdjustItem"
                                @on-check="handleCheckAdjustItem"
                                @on-click="handleClickAdjustItem"
                                @on-sort="handleTaskSorted"
                                @on-delete="handleTaskDeleted"
                                @on-add="handleTaskAdd"
                                @on-confirm-adjust="handleConfirmAdjust"
                            ></train-adjust-list>
                        </div>
                    </div>
                </template>
                <template v-slot:grid-right>
                    <div id="train-list-map" class="train-list-map">
                        <div
                            :id="mapId"
                            :style="{ height: '100%', width: '100%' }"
                        ></div>
                        <polyline-switch :map-controller="mapController" />
                    </div>
                </template>
            </resizable-grids>
            <train-adjust-task-add
                ref="taskAdditionDialog"
            ></train-adjust-task-add>
            <car-scheduling-dialog
                v-if="isArrangeSubmitVisi"
                ref="carScheduling"
                :RwCarVisiable.sync="isArrangeSubmitVisi"
                :inOutType="currInOutType"
                :taskDataList="taskDataList"
                :dispatchSaveFlag="dispatchSaveFlag"
                :checkDispatch="checkDispatch"
                label-task="right"
                @AdmittOk="handleArrangeSubmitOk"
            >
            </car-scheduling-dialog>
            <quick-cancellation-dialog
            :quickCancellationVisiable.sync="quickCancellationVisiable"
            v-if="quickCancellationVisiable"
            :taskDataList="taskDataList"
            @AdmittOk="handleArrangeSubmitOk"
        >
        </quick-cancellation-dialog>
        </div>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import TrainAdjustList from '../component/TrainAdjustList';
import TrainAdjustTaskAdd from '../component/trainAdjustTaskAdd/TrainAdjustTaskAdd';
import ResizableGrids from '../component/ResizableGrids';
import { MapController } from './map/mapController';
import lodash from 'lodash';
import { colorByIndex } from '../utils/colors';
import { PromiseUtils } from '../utils/promise';
import { DispatchStatus, PRIVILEGE_MOVE_CODE } from '../utils/train';
import { StatusValue } from '../utils/statusValue';
import * as api from '../../../../api/trainList';
import CarSchedulingDialog from '../../../../components/dialog/carSchedulingDialog';
import { flatLbxTasks, validateAddingTasks, validateDeletingTasks } from '../utils/lineOrders';
import { TrainAdjustListController } from '../component/TrainAdjustListController';
import { showCopiableMessage } from '../utils/message';
import { I18nMixins } from '@/components/utils/i18n';
import PolylineSwitch from '../component/PolylineSwitch';
import { TrainEntity } from '../entity/trainEntity';
import { TrainLocalEntity } from '../entity/trainLocalEntity';
import { getCarDetail } from '../../../../api/adjustMonitor';
import { mapState } from 'vuex';
import QuickCancellationDialog from '../../../../components/dialog/QuickCancellationDialog';

export default {
    name: 'trainListAdjust',
    components: { PolylineSwitch, ResizableGrids, TrainAdjustTaskAdd, TrainAdjustList, paper, CarSchedulingDialog, QuickCancellationDialog },
    mixins: [I18nMixins],
    data () {
        const mapId = 'BMap-' + parseInt(Date.now() + Math.random());
        return {
            daListController: new TrainAdjustListController(),
            mapId,
            mapController: new MapController(mapId, { isPolyline: true }),
            customerOrderNo: '',
            selected: 1,
            // 待排车的车次
            trainToArrange: {},
            // 排车弹窗是否展示
            isArrangeSubmitVisi: false,
            trainList: [],
            taskDataList: [],
            dispatchSaveFlag: true, // 行排车点击标识，true为算法排车，false为线路排车
            checkDispatch: true, // 开启排车承运商限制
            adjustCheckDisable: false,// 调整监控进入调整页面屏蔽按钮操作
            quickCancellationVisiable: false // 快销预排车

        };
    },
    computed: {
        trains () {
            return this.trainList.map(TrainLocalEntity);
        },
        // 加入发车单/移除发车单 时使用，特权模式
        isPrivilege () {
            return this.$_has(PRIVILEGE_MOVE_CODE);
        },
        // "订单大类", 'IN' 为入库, 字典: IN_OUT_TYPE
        currInOutType () {
            return this.trainToArrange.inOutType || 'IN';
        },
        ...mapState({ user: state => state.user })
    },
    created () {
        this.messenger = PromiseUtils.buildErrorMessenger(this.$message);
        this.initial = lodash.debounce(() => {
            if (this.$route.query.trainNums) {
                this.trainNums = this.$route.query.trainNums.split(',');
                this.adjustCheckDisable = true;
            } else {
                this.trainNums = '';
                this.adjustCheckDisable = false;
            }
            this.getData();
        }, 200);
    },
    mounted () {
        this.initMap();
        this.initial();
    },
    activated () {
        this.initial();
    },
    methods: {
        /// 根据发车单获取路由颜色
        getRouteColor (train) {
            const idx = lodash.findIndex(this.trainList, (d) => d.id === train.id);
            return colorByIndex(idx);
        },
        /// 更新地图路由绘制
        updateRoute (train, toClear) {
            if (toClear) {
                this.mapController.removeRoute(train.id);
            } else {
                if (train.tasks.length === 0) {
                    return;
                }
                this.mapController.addRoute(
                    train.id,
                    { lng: train.tasks[0].startLng || 0, lat: train.tasks[0].startLat || 0 },
                    train.tasks.map(task => ({
                        lng: task.endLng || 0,
                        lat: task.endLat || 0,
                        lbxCount: (task.children && task.children.length) // 是否菜鸟大件
                    })),
                    {
                        color: this.getRouteColor(train)
                    }
                );
            }
        },
        /// 初始化地图
        initMap () {
            this.mapController.initMap();
            this.mapController.on('route-click', (id) => {
                // console.log('route-click', id);
            });
        },
        /// 构造车次接口参数
        createTrainDataParams () {
            /// 如果车次已经存在调整面板，且状态未“待排车”，则保持其状态
            /// -> 将接口返回值与“待排车”车次现有本地数据合并，保持与 this.trainNums 相同的顺序
            return this.trainNums;
        },
        /// 处理车次接口返回数据
        createTrainDataResponse (responseTrainList) {
            // 保持车次信息与 this.trainNums 相同的顺序，补回 “待排车” 车次信息
            const trainMap = new Map();
            for (const train of this.trainList) {
                trainMap.set(train.trainNum, train);
            }
            for (const train of responseTrainList) {
                // TODO: 运单已经为空的车次是否还要展示
                trainMap.set(train.trainNum, train);
            }

            return this.trainNums.map(trainNum => trainMap.get(trainNum)).filter(t => t);
        },
        /// 获取数据
        getData () {
            if (this.$route.query.lineDetailCostId) {
                return getCarDetail({ lineDetailCostId: this.$route.query.lineDetailCostId, type: this.$route.query.type })
                    .then(PromiseUtils.assertResponseSuccess)
                    .then(res => {
                        const locals = TrainLocalEntity.extractLocals(this.trainList);
                        const trainList = this.initialTrainListStatus(res.data.list, locals);
                        this.trainNums = [trainList[0].trainNum];
                        this.trainList = this.createTrainDataResponse(trainList);
                        // 重置排车按钮显隐状态
                        this.trainList.forEach(item => {
                            item.local.checkpointModified = false;
                            item.local.modified = false;
                        });
                        this.mapController.removeAllRoutes();
                        if (this.trainList.length > 0) {
                            // 选中第一条, 展开，并绘制路线
                            const firstTrain = this.trainList[0];
                            TrainLocalEntity.update(firstTrain, { expanded: true, checked: true });
                            this.updateRoute(firstTrain);
                        }

                        this.$nextTick(() => {
                            // 因为 使用到 DOM, 需要等待数据渲染后再进行 sortable 初始化
                            this.daListController.initSortable();
                        });
                    })
                    .catch(err => {
                        this.messenger.w(err);
                    });
            } else {
                return api.lineDetailWithOrder({ trainNumList: this.createTrainDataParams(), cancelFlag: 0 }) // 返回除“已废除”之外的运单
                    .then(PromiseUtils.assertResponseSuccess)
                    .then(res => {
                        const locals = TrainLocalEntity.extractLocals(this.trainList);
                        const trainList = this.initialTrainListStatus(res.data.list, locals);
                        this.trainList = this.createTrainDataResponse(trainList);
                        // 重置排车按钮显隐状态
                        this.trainList.forEach(item => {
                            item.local.checkpointModified = false;
                            item.local.modified = false;
                        });
                        this.mapController.removeAllRoutes();
                        if (this.trainList.length > 0) {
                            // 选中第一条, 展开，并绘制路线
                            const firstTrain = this.trainList[0];
                            TrainLocalEntity.update(firstTrain, { expanded: true, checked: true });
                            this.updateRoute(firstTrain);
                        }

                        this.$nextTick(() => {
                            // 因为 使用到 DOM, 需要等待数据渲染后再进行 sortable 初始化
                            this.daListController.initSortable();
                        });
                    })
                    .catch(err => {
                        this.messenger.w(err);
                    });
            }
        },
        /// 获取单个车次数据
        getTrainData (trainNum) {
            return api.lineDetailWithOrder({ trainNumList: [trainNum], cancelFlag: 0 }) // 返回除“已废除”之外的运单
                .then(PromiseUtils.assertResponseSuccess)
                .then(res => {
                    PromiseUtils.assert(res.data.list && res.data.list.length, '获取车次信息接口返回值错误');
                    PromiseUtils.assert(trainNum === res.data.list[0].trainNum, '获取车次信息接口返回值车次号不正确');

                    const train = res.data.list[0];
                    this.initialTrainListStatus([train], TrainLocalEntity.extractLocals(this.trainList));
                    return train;
                });
        },
        /// 初始化车次的本地状态(或复用初始车次本地状态), 并同步地图路径
        initialTrainListStatus (trainList, locals) {
            for (const train of trainList) {
                TrainEntity.normalize(train);
                TrainLocalEntity.touch(train, locals.get(train.trainNum) || {});
            }
            return trainList;
        },
        /// 查询面板中的订单号并高亮
        handleSearchCustomerOrderNo () {
            let trainIndex = -1;
            let taskIndex = -1;
            for (const [trainIdx, train] of this.trainList.entries()) {
                trainIndex = trainIdx;
                taskIndex = lodash.findIndex(train.tasks, t => t.customerOrderNo === this.customerOrderNo);
                if (taskIndex !== -1) {
                    break;
                }
            }

            if (taskIndex !== -1) {
                // 找到了对应的运单任务
                this.trainList = lodash.cloneDeep(this.trainList).map((train, trainIdx) => {
                    // 选中、展开、绘制车次
                    const isTheTrain = trainIndex === trainIdx;
                    TrainLocalEntity.update(train, { checked: isTheTrain, expanded: isTheTrain });
                    this.updateRoute(train, !isTheTrain);

                    for (const task of train.tasks) {
                        // 高亮选中的 运单任务
                        task._highlight = task.customerOrderNo === this.customerOrderNo;
                    }
                    return train;
                });
            } else {
                // 未找到对应的运单任务
                for (const [trainIdx, train] of this.trainList.entries()) {
                    for (const [taskIdx, task] of train.tasks.entries()) {
                        // 去掉高亮的运单任务
                        if (task._highlight) {
                            train.tasks[taskIdx]._highlight = false;
                            this.$set(this.trainList, trainIdx, train);
                        }
                    }
                }
            }
        },
        /// 点击排车
        handleArrange (data) {
            this.trainToArrange = data.item;
            this.taskDataList = data.item.lineOrderResponseList;
            // 快销判断，特殊排车
            if (this.taskDataList.some(i => i.projectClassify === 'QCO')) {
                this.quickCancellationVisiable = true;
                return false;
            }
            this.isArrangeSubmitVisi = true;
            const params = {
                    carrierName: this.taskDataList[0].carrierName,
                    carrierCode: this.taskDataList[0].carrierCode,
                    supplierCode: this.taskDataList[0].carrierCode,
                    transType: this.taskDataList[0].procurementChannel,
                    tranName: this.taskDataList[0].procurementChannelName,
                    siteCode: this.taskDataList[0].siteCode,
                    transUnitName: this.taskDataList[0].transUnitName,
                    transUnitCode: this.taskDataList[0].transUnitCode
                };
                this.$nextTick(() => {
                    this.$refs.carScheduling.AdmittRuleForm.carrierName = this.taskDataList[0].carrierName;
                    this.$refs.carScheduling.AdmittRuleForm.companyCode = this.taskDataList[0].companyCode;
                    this.$refs.carScheduling.AdmittRuleForm.routeNoList = this.taskDataList.filter(item => item.lineCode).map(item => item.lineCode);
                    this.$refs.carScheduling.AdmittRuleForm.siteCodeList = this.taskDataList.filter(item => item.siteCode).map(item => item.siteCode);
                    this.$refs.carScheduling.getAdvanceValueLists(params);
                });
        },
        /// 处理排车弹框确认按钮
        handleArrangeSubmitOk (data) {
            if (data.state) {
                const params = {
                    ...data.data, // 弹框数据
                    lineOrderList: flatLbxTasks(this.trainToArrange.tasks), // 车次的运单列表
                    trainNum: this.trainToArrange.trainNum // 车次号
                };
                const carSchedulingDialog = this.$refs.carScheduling;
                return Promise.resolve(params)
                    .then(PromiseUtils.do((params) => {
                        PromiseUtils.assert(params.lineOrderList.length > 0, '车次内无运单，不能排车');
                        if (params.preDispatchStrategy !== 'FMCG') {
                            this.isArrangeSubmitVisi = true;
                            carSchedulingDialog.saveLoading = true;
                        }
                    }))
                    .then(api.save) // 调用调整页面的排车接口
                    .then(PromiseUtils.assertSilently) // 确保 res 不为 null
                    .then(res => {
                        const codeNumber = +res.code;
                        if (codeNumber === 0 && typeof res.data === 'string') {
                            const dispatchNo = res.data.split(',')[0];
                            if (params.procurementChannel === '190') {
                                // "采购渠道" 为 “城配长合车”, 跳转到 “配送中心-发车单管理” 并展示“行车路径调整”弹框
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'dispatchOrder',
                                        params: {
                                            name: '/dispatch-order',
                                            dispatchNo: dispatchNo,
                                            carrierName: params.carrierName
                                        }
                                    });
                                }, 200);
                            }
                            setTimeout(() => {
                                this.getData();
                            }, 500);
                            showCopiableMessage(this.$message, `已保存，生成发车单号：${res.data}`, dispatchNo);
                            if (params.vehicleCard && params.vehicleCard !== '*') {
                                this.getPromptTrackType(dispatchNo);
                            }

                            return true;
                        } else if (codeNumber === 200) {
                            // TODO: 这个判断条件应该解释一下
                            this.$message.error(res.msg);
                            return true;
                        }

                        return false;
                    })
                    .then(async (shouldHideDialog) => {
                        if (shouldHideDialog) {
                            this.isArrangeSubmitVisi = false;
                            this.quickCancellationVisiable = false;
                            /// 重新查询数据
                            const train = await this.getTrainData(this.trainToArrange.trainNum);
                            const index = lodash.findIndex(this.trainList, train => train.trainNum === this.trainToArrange.trainNum);
                            this.$set(this.trainList, index, train);
                        }
                    })
                    .catch((err) => {
                        this.messenger.w(err, '排车失败');
                    })
                    .finally(() => {
                        if (params.preDispatchStrategy !== 'FMCG') {
                            carSchedulingDialog.saveLoading = false;
                        }
                    });
            }
        },
        getPromptTrackType (dispatchNo) {
            api.promptTrackType(dispatchNo).then(res => {
                if (res && +res.code === 0 && res.data && +res.data.shippingType === 1) {
                    if (+res.data.isZjxl === 0) {
                        this.$message.warning('该车辆不支持北斗轨迹获取，请要求司机全程打开直通宝');
                    } else if (+res.data.isZjxl === 1) {
                        this.$message.warning('该车辆可通过北斗获取轨迹');
                    } else {
                        this.$message.warning('未知车辆北斗入网状态，请要求司机全程打开直通宝');
                    }
                }
            });
        },
        /// 面板中 checkbox 选中/取消选 中发车单条目
        handleCheckAdjustItem ({ item, isChecked, index }) {
            TrainLocalEntity.update(item, { checked: isChecked });
            this.$set(this.trainList, index, item);
            this.updateRoute(item, !isChecked);
        },
        /// 面板中发车单条目 展开/收拢 运单任务
        handleExpandedAdjustItem ({ item, isExpanded, index }) {
            TrainLocalEntity.update(item, { expanded: isExpanded });
            this.$set(this.trainList, index, item);
        },
        /// 面板中 点击发车单条目
        handleClickAdjustItem ({ item, index }) {
            // unimplimented
        },
        /// 拖动列表中的运单条目, 条目重拍完毕后, 更新 data 和地图显示
        async handleTaskSorted (where, tl) {
            try {
                this.trainList = tl;
                this.updateRoute(tl[where.from.trainIndex]);
                if (where.from.trainIndex !== where.to.trainIndex) {
                    this.updateRoute(tl[where.to.trainIndex]);
                }
                TrainLocalEntity.tryMarkThemModified(this.trainList, [where.from.trainIndex, where.to.trainIndex]);
            } catch (e) {
                this.messenger.w(e);
            }
        },
        /// 减单处理完毕后更新 data 和地图显示
        async handleTaskDeleted ({ trainIndex }, dl) {
            this.trainList = dl;
            if (this.trainList[trainIndex].tasks.length) {
                this.trainList[trainIndex].mileage = await this.getCalculate(this.trainList[trainIndex].tasks);
            }

            TrainLocalEntity.tryMarkModified(this.trainList[trainIndex]);
            this.updateRoute(dl[trainIndex], !dl[trainIndex].tasks.length);
        },
        /// 点击“添加”按钮，弹框
        handleTaskAdd ({ trainIndex, taskIndex, keepData }) {
            const trainTaskNoSet = new Set(this.trainList[trainIndex].tasks.map(task => task.taskNo));
            this.$refs.taskAdditionDialog.open({
                keepData,
                trainTaskNoSet
            })
                .then(PromiseUtils.assertFn(
                    (dialogData) => dialogData.tasksToAdd.length > 0,
                    '请至少勾选一条数据'))
                .then(async (dialogData) => {
                    const train = lodash.cloneDeep(this.trainList[trainIndex]);

                    const taskNoSet = new Set(train.tasks.map(t => t.taskNo));

                    // 接口要求: 待添加的 运单任务 需要去掉 id。 注意调接口后记得将数据同步回来
                    const [tasksToAdd, tasksMayToAdd] = [dialogData.tasksToAdd, dialogData.tasksMayToAdd]
                        .map(tasks => lodash.cloneDeep(tasks)
                            .filter(t => !taskNoSet.has(t.taskNo)) // 去重
                            .map(task => {
                                delete task.id;
                                return task;
                            }));

                    if (tasksToAdd.length < dialogData.tasksToAdd.length) {
                        PromiseUtils.assert(tasksToAdd.length, '过滤掉重复后运单后没有课添加的运单');
                        // 有重复的运单
                        this.$message.warning('有重复的运单, 已过滤掉重复运单');
                    }

                    const extendedTasksToAdd = this.addTasks(
                        train, tasksToAdd, tasksMayToAdd);

                    train.tasks.splice(taskIndex, 0, ...extendedTasksToAdd);
                    train.mileage = await this.getCalculate(train.tasks);
                    this.$set(this.trainList, trainIndex, train);

                    TrainLocalEntity.tryMarkModified(this.trainList[trainIndex]);

                    this.updateRoute(train);

                    this.$refs.taskAdditionDialog.close();
                })
                .catch((e) => {
                    if (e) {
                        this.messenger.w(e, '添加失败');
                    }
                    if (e) {
                        this.handleTaskAdd({ trainIndex, taskIndex, keepData: true });
                    }
                });
        },
        // 获取里程
        async getCalculate (tasks) {
            const params = {
                originAddress: tasks[0].senderDetailAddr,
                destAddresses: tasks.map(i => i.receiverDetailAddr)
            };
            const res = await api.calculate(params);
            if (res && res.code === '0') {
                return res.data;
            } else {
                return 0;
            }
        },
        /// 面板 减单处理(两组之间移动、按钮删除)
        async doDeleteTaskForList (train, taskToDelete) {
            this.deleteTasks(train, [taskToDelete]);

            const newTasks = train.tasks.filter(row => taskToDelete.taskNo !== row.taskNo);

            return [newTasks, taskToDelete, train];
        },
        /// 面板 加单处理(两组之间移动)
        async doAddTaskForList (train, taskToAdd, addAtIndex) {
            const extendedTasksToAdd = this.addTasks(train, [taskToAdd]);

            train.tasks.splice(addAtIndex, 0, ...extendedTasksToAdd);

            return [train.tasks, train];
        },
        /// 减单处理
        deleteTasks (train, taskToDelete) {
            const targetDispatch = {
                // 发车单(车次)正在获取合同号中
                isGainingContract: train.gainingContract === 1
            };

            validateDeletingTasks(this.isPrivilege, targetDispatch, taskToDelete);
            return taskToDelete;
        },
        /// 加单处理, 返回 新的待添加运单任务（LBX运单被压缩到`children`中）
        addTasks (train, tasksToAdd, tasksMayToAdd) {
            // 发车单状态 和 车次状态, 对应（除了 “待排车” 和 “已废除” 外）
            const dispatchStatus = StatusValue.create(+train.dispatchStatus);
            const targetDispatch = {
                // 是否仓配一体
                isWarehouseSendInOne: train.dispatchType !== 2,
                // 是否在途前状态
                isBeforeSend: dispatchStatus.isBefore(DispatchStatus.IN_TRANSIT),
                // 目标发车单仓库列表
                wtWhCode: train.wtWhCode
            };
            return validateAddingTasks(
                this.isPrivilege, targetDispatch, train.tasks, tasksToAdd, tasksMayToAdd);
        },
        /// 确认调整
        handleConfirmAdjust (data) {
            const modifledTrains = this.trains.filter(t => t.local.modified);

            const doAdjust = () => {
                TrainLocalEntity.markThemConfirmed(modifledTrains);
                TrainLocalEntity.markThemCheckpoint(modifledTrains);
                return api.adjustConfirmRecompute({
                    // 调整原因
                    ...data,
                    // 操作人
                    userCode: this.user.userCode,
                    userName: this.user.userName,
                    // 排单编号
                    lineCode: modifledTrains[0].lineCode,
                    // 车次集合
                    lineDetailResponseList: modifledTrains.map(t => ({
                        id: t.id,
                        // 车次订单集合
                        lineOrderResponseList: flatLbxTasks(t.tasks).map(tsk => ({
                            // 运单号
                            taskNo: tsk.taskNo
                        }))
                    }))
                })
                    .then(PromiseUtils.assertResponseSuccess)
                    .then(() => this.getData())
                    .then(() => {
                        this.$message.success('操作成功');
                    })
                    .catch((err) => {
                        this.messenger.w(err);
                    });
            };

            const validateResult = TrainEntity.adjustPreConfirm(modifledTrains);
            if (!validateResult.valid) {
                return this.$confirm(validateResult.message, '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => doAdjust())
                    .catch(() => { });
            } else {
                return doAdjust();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.train-list-adjust-wrapper {
    display: flex;
    padding: 10px;
    background-color: #f6f8fa;

    .train-list-list {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
        background-color: white;
        height: 100%;

        position: relative;

        .train-list-visible-toggle {
            position: absolute;
            top: 8px;
            right: -16px;
            height: 28px;
            line-height: 28px;
            background-color: #3c3c3c66;
            color: white;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            z-index: 999;
        }

        .train-list-adjust-search {
            display: flex;
            padding: 10px 14px;
            border-bottom: 1px solid #ebeef5;
        }

        .train-list-adjust-list {
            height: calc(100vh - 140px);
            overflow-y: auto;
            padding: 10px 14px;
        }
    }

    .train-list-map {
        position: relative;
        //padding-left: 8px;
        width: 100%;
        height: calc(~'100vh - 60px');
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
    }
}
</style>

<style lang="less">
// 去掉百度地图地 Logo
.anchorBL {
    display: none;
}

.train-list-adjust-paper.layout-content {
    padding: 0;
    margin: 0;
}

.train-list-map .bmap-container {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>
